import { Injectable, signal } from '@angular/core';
import { ChildMenu } from '../header-model';

@Injectable({ providedIn: 'root' })
export class MenuOverlayEventsService {

  // Signals from menu to header
  linkClick = signal<ChildMenu | null>(null);

  menuClick = (sub: ChildMenu) => {
    this.linkClick.set(sub);
  }
}
